export default "__VITE_ASSET__BtreHBgL__"